export var USER_FLAVORS;
(function (USER_FLAVORS) {
    USER_FLAVORS["DEVELOPER"] = "developer";
    USER_FLAVORS["NO_CODE"] = "noCode";
})(USER_FLAVORS || (USER_FLAVORS = {}));
export const calculateUserFlavor = (colors = {}) => {
    // if (
    //   colors?.registrationColor === USER_FLAVORS.DEVELOPER ||
    //   colors?.postRegistrationColors?.includes(USER_FLAVORS.DEVELOPER)
    // ) {
    // }
    return USER_FLAVORS.DEVELOPER; // mark all users as DEVELOPER experience and remove the BLOCKS experience
    // return USER_FLAVORS.NO_CODE;
};
//# sourceMappingURL=calculateUserFlavor.js.map